module.exports = __webpack_public_path__ + "img/yoga.cf16d82c.jpg";